<template lang="pug">
  div
    div.toolbar
      div.line
        h1.title Баланс характеристик
      div.line
        div.parameter.parameter--right
          select.reg-operator
            option ТКО/Все отходы
            option ТКО/Все отходы 2
        form.search(@submit.prevent="letSearch")
          input(type="search" placeholder="" v-model="search")
        div.filter(v-if="false")
          button.filter__button(@click="find = !find") Фильтр

        div.parameters
          select.unit
            option Ед. изм.
            option Тонн
          select.year(@change="changeYear" v-model="year")
            option(value='') Год
            option 2017
            option 2016
            option 2015
        div.actions-panel(v-if="actionsPanelShow()")
          button.actions-panel__button.btn-columns(title="Отобразить столбцы" @click="filter = !filter" v-if="colShow()")
          div.filter-popup(v-show="filter") /Здесь будут столбцы/
            .item(v-for="(item, i, n) in $parent.metaFields")
              input.checkbox(type="checkbox" :id="'popup-checkbox' + n" v-model="$parent.visibleFields[i]")
              label(:for="'popup-checkbox' + n") {{ $parent.metaFields[i].label }}
            div.item



    div.content
      div.table.reestr
        table
          thead
            th
              div.sortable.text текст
              div.sortable.arrows
                span.up
                span.down
            th
              div.sortable.text текст
              div.sortable.arrows
                span.up
                span.down
            th
              div.sortable.text текст
              div.sortable.arrows
                span.up
                span.down
            th(v-if="showButtons")

          tbody
            tr.item.first-level.open
              td(@click="expand(value, valuesIndex, values)")
                span.arrow
                span 123
              td
                span 123
              td
                span 123
              td(v-if="showButtons")
                editButtons(:currentItem="value")
            tr.item.second-level
              td(@click="expand(value, valuesIndex, values)")
                span 123
              td
                span 123
              td
                span 123
              td(v-if="showButtons")
                editButtons(:currentItem="value")
            tr.item.first-level.close
              td(@click="expand(value, valuesIndex, values)")
                span.arrow
                span 123
              td
                span 123
              td
                span 123
              td(v-if="showButtons")
                editButtons(:currentItem="value")

    div.footer-nav
      div.actions-filter-panel
        button.actions-filter-panel__button.default.download Скачать
      //div.paginator
        span Показывать по
        select
          option 10
          option 25
          option 50
          option 100
        div.page-nav
          span.navigate.prev
          input(type='text')
          span из ?
          span.navigate.next


</template>

<script>
  import editButtons from './tables-component/partials/garbageEditButtons.vue';
  import expandRow from './tables-component/AtuExpandRow.vue';

  export default {
    data() {
      return {
        checks: [],
        open: false,
        rowClass: '',
        addedTo: {},
        search: '',
        filter: false,
        find: false,
        year: ''
      };
    },
    methods: {
      actionsPanelShow() {
        return true;
      },
      colShow() {
        return true;
      },
      changeYear() {
        this.$emit('changeYear', this.year);
      },
      letSearch() {
        let srch = this.search;
        this.$emit('letSearch', srch);
      }
    },

    computed: {
      showButtons() {
        return (this.$route.name !== 'Банк данных технологий');
        // return false;
      }
    },
    created() {
      // this.checking();
    },
    components: {
      editButtons, expandRow
    }
  };
</script>

<style lang="scss">

</style>
